import React from 'react';
import { motion } from 'framer-motion';
import { Upload, Printer, Truck } from 'lucide-react';
const steps = [{
  number: '01',
  title: 'Submit Artwork',
  description: 'Upload your vector files or high-res PNGs. We review every file for printability.',
  icon: Upload
}, {
  number: '02',
  title: 'We Print',
  description: 'Our team gets to work using industrial-grade equipment for perfect results.',
  icon: Printer
}, {
  number: '03',
  title: 'We Ship Fast',
  description: 'Your order is quality checked, packed, and shipped directly to your door.',
  icon: Truck
}];
export function ProcessSection() {
  return <section className="py-24 bg-atomic-charcoal relative overflow-hidden" data-id="element-297">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-298"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-299">
        <div className="text-center mb-16" data-id="element-300">
          <span className="text-atomic-green font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-301">
            How It Works
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-302">
            Streamlined Production
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-303">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-atomic-green/30 to-transparent" data-id="element-304"></div>

          {steps.map((step, index) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="relative flex flex-col items-center text-center" data-id="element-305">
              <div className="w-24 h-24 rounded-full bg-atomic-black border-4 border-atomic-charcoal flex items-center justify-center mb-6 relative z-10 shadow-xl" data-id="element-306">
                <step.icon className="text-atomic-green" size={32} data-id="element-307" />
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-atomic-green rounded-full flex items-center justify-center text-black font-bold text-sm border-2 border-atomic-charcoal" data-id="element-308">
                  {step.number}
                </div>
              </div>

              <h3 className="text-2xl font-bold text-white mb-3" data-id="element-309">
                {step.title}
              </h3>
              <p className="text-gray-400 max-w-xs mx-auto" data-id="element-310">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}